import EmptyStateIcon from 'components/common/EmptyStateIcon';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import SelectedProduct from './SelectedProduct';
import * as Ui from './SelectedProductsList.styles';

const SelectedProductsList = ({ products, onRemove }) => {
  const { t } = useTranslation('ownerPortal');
  return (
    <Ui.SelectedProducts>
      <Ui.SelectedProductsText>{t('Looks.selectedProducts')}</Ui.SelectedProductsText>
      {products.length > 0 ? (
        products.map((parent, index) => {
          if (!parent.child_products?.[0]) return null;
          const parentName = parent.name || parent.child_products?.[0]?.parent_product?.name;
          const isLastProduct = index === products.length - 1;
          return (
            <React.Fragment key={`parent-${parent.uid}`}>
              <Ui.SelectedProduct>
                <Ui.ParentProductName>{`${parentName ? parentName.toUpperCase() : ''} (${parent.child_products?.length ?? 0})`}</Ui.ParentProductName>
                <Ui.SelectedProductContainer>
                  {(parent.child_products?.length ?? 0) > 0 &&
                    parent.child_products.map((product) => (
                      <SelectedProduct
                        key={`${product.uid}-added`}
                        product={product}
                        onRemove={() => onRemove(parent.uid, product.uid)}
                      />
                    ))}
                </Ui.SelectedProductContainer>
              </Ui.SelectedProduct>
              {!isLastProduct && <Ui.Divider />}
            </React.Fragment>
          );
        })
      ) : (
        <Ui.EmptyStateWrapper>
          <EmptyStateIconStyled />
          <Ui.NoProductsMessage>{t('Looks.noProducts')}</Ui.NoProductsMessage>
        </Ui.EmptyStateWrapper>
      )}
    </Ui.SelectedProducts>
  );
};

const EmptyStateIconStyled = styled(EmptyStateIcon)`
  width: 60px;
  height: 60px;
  margin-bottom: 12px;
  opacity: 0.6;
  @media (max-width: 576px) {
    width: 40px;
    height: 40px;
    margin-bottom: 8px;
  }
`;

SelectedProductsList.propTypes = {
  products: PropTypes.array.isRequired,
  onRemove: PropTypes.func.isRequired,
};

export default SelectedProductsList;
